import React, { Fragment } from "react";
import Formatters from "../../shared/utils/Formatters";

export default function AmortizingSummary({
  disbursedAmount,
  interestAmount,
  repaymentAmount,
  serviceFee,
  serviceFeeAmount,
  totalRepaymentAmount,
  totalInterestAmount,
  equivalentAor,
  isForPayment
}) {
  const convenienceFeeLabel = () =>{
    if(serviceFee === 0){
      return (
        <span>
          <span className="_fontSize--small _textDecoration_line-through">
            + ₱ {Formatters.currencyDecimal(serviceFeeAmount)}
          </span>
          {' '} ₱ {Formatters.currencyDecimal(serviceFee)}
        </span>
      );
    }else{
      return (
        <span>+ ₱ {Formatters.currencyDecimal(serviceFeeAmount)}</span>
      );
    }
  }
  const convenienceFeeNote = () =>{
    if(serviceFee === 0 ){
      return (
        <small className=' -secondary _marginBottom--small'>
          <sup>2</sup> The convenience fee has been waived since you're on a subscription fee model.
          We don't charge any other fees like documentary stamp taxes or notarization fees.
        </small>
      );
    }
    else{
      return (
        <small className=' -secondary _marginBottom--small'>
          <sup>2 </sup>A convenience fee of {serviceFee}% is deducted before you receive the loan.
          We don't charge any other fees like documentary stamp taxes or notarization fees.
        </small>
      );
    }
  }

  return (
    <Fragment>
      <section id='amortizing_summary' className='cardSection _alignLeft'>
        <p className='subhead -darkBlue _alignCenter'> Total you will pay </p>
        <div className='_displayFlex _justifyContent-space-between'>
          <h3 className='data -darkBlue _fontSize--small-mobileOnly'>
            Amount {isForPayment ? 'supplier' : 'you'} will receive
          </h3>
          <h3
            className='data -darkBlue _fontSize--small-mobileOnly'
            data-testid='amortizing-disbursed-amount'
          >
            ₱ {Formatters.currencyDecimal(disbursedAmount)}
          </h3>
        </div>
        <div className='_displayFlex _justifyContent-space-between'>
          <h3
            className='_fontSize--xsmall-mobileOnly byline'
            data-testid='amortizing-processing-fee-title'
          >
            + Convenience Fee <sup>2</sup>
          </h3>
          <h3
            className='_fontSize--xsmall-mobileOnly byline'
            data-testid='amortizing-processing-fee'
          >
            {convenienceFeeLabel()}
          </h3>
        </div>
        <div className='_displayFlex _justifyContent-space-between _borderBottom'>
          <h3 className='_fontSize--xsmall-mobileOnly byline'>
            + Interest ({Formatters.currencyDecimal(equivalentAor, false)}%/month){' '}
            <sup>3</sup>
          </h3>
          <h3
            className='_fontSize--xsmall-mobileOnly byline'
            data-testid='amortizing-interest'
          >
            + ₱ {Formatters.currencyDecimal(totalInterestAmount)}
          </h3>
        </div>
        <div className='_displayFlex _justifyContent-space-between _paddingTop--small'>
          <h3 className='-darkBlue _fontSize--small-mobileOnly'>
            Total you will pay
          </h3>
          <h3
            className='-darkBlue _fontSize--small-mobileOnly'
            data-testid='amortizing-loan-amount'
          >
            = ₱ {Formatters.currencyDecimal(totalRepaymentAmount)}
          </h3>
        </div>
        <small className='-secondary'>
          <sup>1</sup> The loan term and payment schedule above may change based
          on your time of confirmation and approval of your loan request.
        </small>
        <br />
        <br />
        {convenienceFeeNote()}
        <br />
        <br />
        <small className='-secondary'>
          <sup>3</sup> The interest you will pay is equivalent to{' '}
          {Formatters.currencyDecimal(equivalentAor)}% of the total principal
          amount per month.
        </small>
      </section>
    </Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/features/loans/components/AmortizingSummary.js